/** Table classes for the iOS-style pages. Wrap the <table> in `wrap` so cell padding lines up with the panel edge. */
export const tbl = {
  wrap: '-mx-3 overflow-x-auto',
  table: 'w-full text-[13px] text-gray-900',
  headRow: 'border-b border-black/[0.06] text-left text-[12px] text-gray-500',
  th: 'whitespace-nowrap px-3 py-2 font-medium',
  row: 'border-b border-black/[0.04] last:border-0 motion-safe:transition-colors hover:bg-gray-50',
  td: 'whitespace-nowrap px-3 py-2.5',
  num: 'text-right tabular-nums',
  muted: 'text-[12px] text-gray-500 tabular-nums',
  empty: 'py-8 text-center text-[13px] text-gray-500',
};
